<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Seguimiento
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Seguimiento
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-flex(xs12)
              v-layout(wrap)
                v-flex(xs6 sm3 style='margin-top:10px;margin-bottom:4px;')
                  v-select(outline
                    :items="clientes"
                    v-model="filtroCli"
                    style='padding-left: 15px;'
                    label="Cliente:")
                v-flex(xs6 sm3 style='display: flex;padding-left: 20px;align-items: center;')
                  v-btn(icon style="background:#4d9bd3;border-radius:10px;" @click='busqueda()').elevation-4
                    v-icon(color='white') search
        l-map(id='mapa' :center='[centrarmapa.lat, centrarmapa.lng]' :zoom='zooom' style='width: 100%; height: 500px')
          l-tile-layer(:url='tileUrl' :attribution='tileAttribution')
          l-marker(
            v-for='(item, idx) in marcadores'
            :key='idx'
            :lat-lng='[item.coordenadas.lat, item.coordenadas.lng]'
          )
            l-popup
              div(style='display:flex;flex-direction:column;min-width:150px;')
                span(v-if='item.cliente') <b> Cliente: </b> {{item.cliente}}
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl:       'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl:     'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

export default {
  name: "mSeguimientoCli",
  components: { LMap, LTileLayer, LMarker, LPopup },
  data: vm => ({
    dialog4: false,
    ruta: serverImg,
    centrarmapa: { lat: 10.0738900, lng: -69.3227800 },
    zooom: 12,
    tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    tileAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    filtroCli: "",
    info: {},
    marcadores: [],
    clientes: [],
  }),
  created() {
    this.initialize();
  },
  methods: {
    async busqueda() {
      this.marcadores = [];
      this.dialog4 = true;
      await Api.get("cliente/seguimiento?filtro="+this.filtroCli).then(res => {
        res.data.forEach(el=>{
            this.marcadores.push({
                icono: null,
                cliente: el.cli_des.trim(),
                coordenadas: {
                    lat: typeof el.campo7 === 'string' ? parseFloat(el.campo7.trim()) : el.campo7,
                    lng: typeof el.campo8 === 'string' ? parseFloat(el.campo8.trim()) : el.campo8,
                }
            })
        })
        this.dialog4 = false
      }).catch(err => {
        this.dialog4 = false
      })
    },
    async initialize() {
      this.dialog4 = true
      this.clientes = []
      this.marcadores = []
      this.clientes.push({
        text: "Todos",
        value: "1"
      })
      this.filtroCli = "1"
      await Api.get("cliente/seguimiento?filtro="+this.filtroCli).then(res => {
        console.log(res.data)
        res.data.forEach(el=>{
            this.clientes.push({
                text: el.cli_des.trim(),
                value: el.co_cli
            })
            this.marcadores.push({
                icono: null,
                cliente: el.cli_des.trim(),
                coordenadas: {
                    lat: typeof el.campo7 === 'string' ? parseFloat(el.campo7.trim()) : el.campo7,
                    lng: typeof el.campo8 === 'string' ? parseFloat(el.campo8.trim()) : el.campo8,
                }
            })
        })
        console.log(this.marcadores)
        this.dialog4 = false
      }).catch(err => {
        this.dialog4 = false
      })
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/seguimiento.scss";
</style>